var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { spenttimeDebug as debug } from '../modules/debug';
import SpenttimeHandler from './spenttime.class';
import { SPENTTIME_STATES } from '../constants';
import { sendStatistics } from '../modules/spenttime/measurement';
import { jsonParse } from '../utils/jsonParse';
/**
 * Aggregator
 * All events call the methods of this class, which sets the current state
 * Based on the status, the measurement of the time spent is started, stopped, or data is sent to the server
 */
var StateSwitch = /** @class */ (function () {
    /**
     * Constructor
     */
    function StateSwitch(verifiedConfig) {
        this._config = verifiedConfig;
        this.containerIsVisible = false;
        this.pageIsVisible = true;
        this.userIsSleeping = false;
        this.containerSpenttime = new SpenttimeHandler();
        this.itemsState = {};
    }
    Object.defineProperty(StateSwitch.prototype, "config", {
        get: function () {
            return this._config;
        },
        enumerable: false,
        configurable: true
    });
    StateSwitch.prototype.getStatistics = function (reset) {
        if (reset === void 0) { reset = false; }
        // container
        var data = {
            time: this.containerSpenttime.getSpenttimeInSeconds(),
        };
        if (reset) {
            this.containerSpenttime.reset();
        }
        // items
        if (this.config.items) {
            data.items = [];
            for (var id in this.itemsState) {
                if (this.itemsState[id].spenttime.wasChange) {
                    var finalSpenttime = this.itemsState[id].spenttime.getSpenttimeInSeconds();
                    if (finalSpenttime > 0) {
                        var itemStatistic = __assign(__assign({}, this.itemsState[id].hitData), { id: id, time: finalSpenttime });
                        data.items.push(itemStatistic);
                    }
                    else {
                        if (this.itemsState[id].spenttime.getState() !== SPENTTIME_STATES.running && reset) {
                            Reflect.deleteProperty(this.itemsState, id);
                        }
                    }
                    if (this.itemsState[id] && reset) {
                        this.itemsState[id].spenttime.reset(id);
                    }
                }
            }
        }
        return data;
    };
    /**
     * Starts or pauses the measurement of the spent time on the CONTAINER
     */
    StateSwitch.prototype.updateContainerSpenttimeAction = function () {
        if (this.containerIsVisible && this.pageIsVisible && !this.userIsSleeping) {
            this.containerSpenttime.run();
        }
        else {
            this.containerSpenttime.pause();
        }
    };
    StateSwitch.prototype.getState = function () {
        return {
            containerIsVisible: this.containerIsVisible,
            pageIsVisible: this.pageIsVisible,
            userIsSleeping: this.userIsSleeping,
        };
    };
    /**
     * Entry point for setting the new stat
     * @param commonState object
     */
    StateSwitch.prototype.setState = function (commonState) {
        var isChange = false;
        // State update
        if ('userIsSleeping' in commonState && this.userIsSleeping !== commonState.userIsSleeping) {
            this.userIsSleeping = commonState.userIsSleeping;
            isChange = true;
        }
        if ('containerIsVisible' in commonState && this.containerIsVisible !== commonState.containerIsVisible) {
            this.containerIsVisible = commonState.containerIsVisible;
            isChange = true;
        }
        if ('pageIsVisible' in commonState && this.pageIsVisible !== commonState.pageIsVisible) {
            this.pageIsVisible = commonState.pageIsVisible;
            isChange = true;
        }
        if (isChange) {
            this.updateContainerSpenttimeAction();
            if ('userIsSleeping' in commonState || 'pageIsVisible' in commonState) {
                this.updateAllItemsSpenttimeAction();
            }
        }
    };
    /**
     * Starts or pauses the measurement of the spent time on the ITEM
     * @param id Item id
     */
    StateSwitch.prototype.updateItemSpenttimeAction = function (id) {
        if (this.itemsState[id].isVisible && this.pageIsVisible && !this.userIsSleeping) {
            this.itemsState[id].spenttime.run(id);
            this.sendStatisticsIfEnoughItems();
        }
        else {
            this.itemsState[id].spenttime.pause(id);
        }
    };
    /**
     * Starts or pauses the measurement of the spent time on the ALL ITEMS
     */
    StateSwitch.prototype.updateAllItemsSpenttimeAction = function () {
        for (var id in this.itemsState) {
            this.updateItemSpenttimeAction(id);
        }
    };
    /**
     * This method will be called from events when the item changes visibility
     * @param id Item id
     * @param itemIsVisible The item is visible (true) or not (false)
     */
    StateSwitch.prototype.setItemState = function (id, itemIsVisible, itemElement) {
        if (itemElement === void 0) { itemElement = null; }
        if (!this.config.items) {
            return;
        }
        // new item
        if (!(id in this.itemsState)) {
            if (!itemIsVisible) {
                return;
            }
            this.itemsState[id] = {
                spenttime: new SpenttimeHandler(this.config.items.measurementStartDelay, id),
                isVisible: itemIsVisible,
                hitData: itemElement ? jsonParse(itemElement.getAttribute(this.config.items.attributeWithDopDetails)) : {},
            };
            this.updateItemSpenttimeAction(id);
            return;
        }
        // existing item
        if (this.itemsState[id].isVisible !== itemIsVisible) {
            this.itemsState[id].isVisible = itemIsVisible;
            this.updateItemSpenttimeAction(id);
        }
    };
    /**
     * Counts over how many items there was a measurement (number)
     * and sends hit if number >= config.items.numberOfItemsInHit
     */
    StateSwitch.prototype.sendStatisticsIfEnoughItems = function () {
        var number = 0;
        for (var id in this.itemsState) {
            if (this.itemsState[id].spenttime.wasChange && this.itemsState[id].spenttime.getSpenttimeInSeconds() > 0) {
                number++;
            }
        }
        debug("Current processed number of items: ".concat(number));
        if (number >= this.config.items.numberOfItemsInHit) {
            sendStatistics();
        }
    };
    return StateSwitch;
}());
export default StateSwitch;
